import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import HeaderFooter from '../HeaderFooter/headerFooter';

const StyledWrapper = styled.div`
  text-align: left;
  margin-left: 70px;
  color: ${({ theme }) => theme.color.first};
  font-size: ${({ theme }) => theme.font.size.xxs};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-family: 'Open Sans', sans-serif;
  ${({ theme }) => theme.mq.tablet} {
    font-size: ${({ theme }) => theme.font.size.s};
    margin-left: 40vw;
  }
  ${({ theme }) => theme.mq.desktop} {
    font-size: ${({ theme }) => theme.font.size.sm};
    margin-left: 0;
  }
  ${({ theme }) => theme.mq.big} {
    padding: 0 40px;
  }
`;

const StyledParagraph = styled.p`
  text-align: left;
  color: ${({ theme }) => theme.color.first};
  font-size: ${({ theme }) => theme.font.size.xxs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-family: 'Open Sans', sans-serif;
  line-height: 26px;
  margin: 0 0 20px;
`;

const FooterBox = ({ title, children }) => {
  let header = useRef(null);
  let paragraph = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: header,
      },
    });
    tl.from(header, {
      opacity: 0,
      rotationX: -150,
      duration: 1,
    }).from(paragraph, {
      y: 200,
      autoAlpha: 0,
      duration: 0.8,
      ease: 'circ',
    });
  }, []);
  return (
    <StyledWrapper>
      <HeaderFooter
        ref={el => {
          header = el;
        }}
      >
        {title}
      </HeaderFooter>
      <StyledParagraph
        ref={el => {
          paragraph = el;
        }}
      >
        {children}
      </StyledParagraph>
    </StyledWrapper>
  );
};

FooterBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FooterBox;
